export default {
  title: {
    id: 'bo_sellers-orders-components-orders_table-title',
    defaultMessage: 'Orders Table',
  },
  order: {
    id: 'bo_sellers-orders-components-orders_table-order_details',
    defaultMessage: 'Order details',
  },
  shipping: {
    id: 'bo_sellers-orders-components-orders_table-shipping_details',
    defaultMessage: 'Shipping details',
  },
  orderLines: {
    id: 'bo_sellers-orders-components-orders_table-order_line_details',
    defaultMessage: 'Order line item details',
  },
  payments: {
    id: 'bo_sellers-orders-components-orders_table-payment_details',
    defaultMessage: 'Payment details',
  },
  status: {
    id: 'bo_sellers-orders-components-orders_table-status',
    defaultMessage: 'Status',
  },
  actions: {
    id: 'bo_sellers-orders-components-orders_table-actions',
    defaultMessage: 'Actions',
  },
  paymentsDetailsTooltip: {
    id: 'bo_seller.orders.components.table.payment_details_tooltip',
    defaultMessage:
      "The total price can include a Customer Commission Fee for selected listings. For these listings, you'll receive a payout equal to your BackBox price. The Customer Commission Fee will be paid by the customer.",
  },
} as const
